window.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector('body');
  if (body.classList.contains("home")) {
    // const viewportWidth =
    //   window.innerWidth || document.documentElement.clientWidth;
    // if (viewportWidth > 1154) {
    //   const video = document.getElementById("homevideo");
    //   const videoMp4 = document.createElement("source");
    //   const videoWebm = document.createElement("source");
    //   videoMp4.setAttribute("type", "video/mp4");
    //   videoMp4.setAttribute("src", "wp-content/themes/masaz-tantryczny.mp4");
    //   videoWebm.setAttribute("type", "video/webm");
    //   videoWebm.setAttribute("src", "wp-content/themes/masaz-tantryczny.webm");
    //   video.appendChild(videoMp4);
    //   video.appendChild(videoWebm);
    // }
  


  const video = document.getElementById("homevideo");
  const videoOverlay = document.getElementById("de-video-overlay");
  const textCenter = document.getElementById("de-video-content");


  setInterval(() => {
    const videoHeight = video.clientHeight;
    const videoOverlayHeight = videoOverlay.clientHeight;
    if (videoHeight !== videoOverlayHeight) {
      videoOverlay.style.height = videoHeight + "px";
      textCenter.style.height = videoHeight + "px";
    }
  }, 0);
}
  
//   setTimeout(function(){
//     console.log(video.clientHeight);
// }, 500);


// setTimeout(function(){
//   console.log(videoOverlay.clientHeight);
// }, 0);









});

